import React from "react";
import { Link } from "react-router-dom";

export default function SubscriptionCancel() {
  return (
    <div className="page max-w-2xl">
      <section className="card text-center">
        {/* Icon */}
        <div
          className="mx-auto mb-3 grid h-16 w-16 place-items-center rounded-full border border-white/10 shadow-card ring-2"
          style={{ boxShadow: "0 10px 25px rgba(0,0,0,.35)" }}
        >
          <div className="h-14 w-14 grid place-items-center rounded-full bg-white/10 text-slate-200 ring-1 ring-white/20">
            <svg viewBox="0 0 24 24" className="h-7 w-7">
              <path fill="currentColor" d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
            </svg>
          </div>
        </div>

        <div className="flex items-center justify-center gap-2 flex-wrap">
          <h1 className="font-display text-3xl md:text-4xl">Checkout Canceled</h1>
          <span className="badge bg-white/10 text-slate-200">No charge</span>
        </div>

        <p className="mt-3 text-slate-300">
          Your subscription purchase was canceled. You weren’t charged. You can resume anytime.
        </p>

        <div className="mt-6 flex flex-wrap items-center justify-center gap-2">
          <Link to="/subscribe" className="btn-primary">View plans</Link>
          <Link to="/" className="btn-secondary">Back to home</Link>
        </div>
      </section>
    </div>
  );
}
